import React from "react";

function Basics(props) {

    return (
        <>
            <aside className="basics">
                <div className="basics-title-container text-center d-flex justify-content-between">
                    <div className="basics-title">
                        <h4>Basics</h4>
                    </div>
                    <img src="/images/basics.png" className="basics-logo"></img>
                </div>
                <div className="widget-body">

                    <div className="booktext" dangerouslySetInnerHTML={{ __html: props.workshop.basics }} />

                </div>
            </aside>
        </>
    );
}

export default Basics;
